import { isObservable } from 'mobx';
import { typeof as _typeof, toConsumableArray as _toConsumableArray } from '../_virtual/_rollupPluginBabelHelpers.js';
import usePrefix from './use-prefix.js';

function splitName(name) {
  if (typeof name !== 'string') {
    return [];
  }

  return name.split(/[\[\]\.]/).filter(function (part) {
    return part !== "";
  });
}

function getPrefixFor(context) {
  var prefix = usePrefix();

  if (typeof prefix === 'undefined' || prefix === null) {
    return null;
  }

  if (isObservable(prefix)) {
    return prefix.get(context);
  }

  if (_typeof(prefix) === 'object' && prefix[context]) {
    return prefix[context];
  }

  if (typeof prefix === 'string') {
    return prefix;
  }

  return null;
}

function useName() {
  var baseName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type;

  if (!type) {
    type = "name";
  }

  var parts = [];
  var prefix = getPrefixFor(type);

  if (prefix !== null && typeof prefix !== 'undefined') {
    if (_typeof(prefix) === 'object') {
      prefix = '';
    }

    if (typeof prefix !== 'string') {
      prefix = prefix + "";
    }

    if (prefix !== '') {
      parts.push.apply(parts, _toConsumableArray(splitName(prefix)));
    }
  }

  if (typeof baseName === 'string') {
    parts.push.apply(parts, _toConsumableArray(splitName(baseName)));
  }

  return parts.join('.');
}

export default useName;
//# sourceMappingURL=use-name.js.map
